"use client";

import type { ReactNode } from "react";

export interface ToolIcon {
  icon: ReactNode;
  label: string;
}

export default function ToolsMarquee({
  tools,
  size = "md",
  slow = false,
}: {
  tools: ToolIcon[];
  size?: "sm" | "md";
  slow?: boolean;
}) {
  const boxSize = size === "sm" ? "h-9 w-9" : "h-14 w-14";
  const fontSize = size === "sm" ? 16 : 24;
  const track = [...tools, ...tools];

  return (
    <div
      className="relative overflow-hidden"
      style={{
        maskImage: "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
        WebkitMaskImage: "linear-gradient(90deg, transparent, black 12%, black 88%, transparent)",
      }}
    >
      <div className={`af-marquee-track flex w-max items-center gap-4 ${slow ? "af-marquee-track--slow" : ""}`}>
        {track.map(({ icon, label }, i) => (
          <div
            key={`${label}-${i}`}
            title={label}
            className={`flex ${boxSize} shrink-0 items-center justify-center rounded-2xl border border-[var(--af-border)] bg-[var(--af-bg)] text-[var(--af-muted)] transition hover:text-[var(--af-accent)]`}
            style={{ boxShadow: "var(--af-shadow)", fontSize }}
          >
            {icon}
          </div>
        ))}
      </div>
    </div>
  );
}
